import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { setIsOpen } from 'store/slices/businessSlice';
import Header from '../Header/Header';
import { Row, Col, Container } from 'reactstrap';
import { Helmet } from 'react-helmet-async';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputFocus: false
    };
  }

  componentDidMount() {
    this.props.setIsOpen(false);
    document.body.classList.toggle('index-page');
  }

  componentWillUnmount() {
    document.body.classList.toggle('index-page');
  }

  render() {
    const { t, fluid, fullWidth } = this.props;
    const isFluid = fluid || fullWidth;
    console.log('Layout props: ', this.props);
    return <>
        <Header />
        <Helmet>
          <title>{t("HeresMyInfo - Contact Sharing")}</title>
        </Helmet>
        {
        /* <Container style={{ border: '2px solid green' }}> */
      }
        <div className={`global-page ${isFluid ? 'global-page-fluid' : ''}`}>
          <Container fluid={true} className={`main-content ${isFluid ? 'main-content-fluid' : ''}`}>
            {
            /* Background CSS can go here */
          }

            <Row>
              {
              /* Save for testing borders */
            }
              {
              /* style={{ border: '2px solid green' }} */
            }
              <Col>
                {this.props.children}
              </Col>

            </Row>

          </Container>
        </div>
        <footer className='fixed-bottom bg-white' style={{
        padding: '10px 0',
        borderTop: '1px solid var(--minimal-border)'
      }}>
          <Container fluid>
            <Row>
              <Col className='text-center'>
                <h6 style={{
                margin: 0,
                color: '#666',
                fontSize: '14px'
              }}>{t("All rights reserved, HMIAuth, LLC. 2015-")}{new Date().getFullYear()} |
                  <Link to='/privacy' style={{
                  marginLeft: '10px',
                  marginRight: '10px',
                  color: 'var(--minimal-text-secondary)',
                  textDecoration: 'none'
                }}>{t("Privacy Policy")}</Link> |
                  <Link to='/terms' style={{
                  color: 'var(--minimal-text-secondary)',
                  textDecoration: 'none'
                }}>{t("Terms and Conditions")}</Link>
                </h6>
              </Col>
            </Row>
          </Container>
        </footer>
      </>;
  }

}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

const mapDispatchToProps = dispatch => ({
  setIsOpen: () => dispatch(setIsOpen(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Layout));